<template>
    <div class="create-post">
            	<div class="row">
            		<div class="col-md-9 col-sm-9">
                  <div class="form-group">
                    <img src="http://placehold.it/300x300" alt="" class="profile-photo-md" />
                    <textarea v-model="search_words" name="texts" id="exampleTextarea" cols="100" rows="1" class="form-control" placeholder="Search: enter name or handle or hashtag"></textarea>
                  </div>
                  <div class="form-group" style="padding-left:5em;">
                      <label class="radio-inline">
                        <input type="radio" v-model="search_type" value="business" id="business">Business
                      </label>
                      <label class="radio-inline">
                        <input type="radio" v-model="search_type" value="product" id="product">Product/Service
                      </label>
                  </div>
                </div>
            		<div class="col-md-3 col-sm-3">
                  <div class="tools">
                    <!-- <ul class="publishing-tools list-inline">
                      <li><a href="#"><i class="ion-compose"></i></a></li>
                      <li><a href="#"><i class="ion-images"></i></a></li>
                      <li><a href="#"><i class="ion-ios-videocam"></i></a></li>
                      <li><a href="#"><i class="ion-map"></i></a></li>
                    </ul> -->
                    <button class="btn btn-primary pull-right" @click="search">Search</button>
                  </div>
                </div>
            	</div>
    </div>
</template>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'SearchBox',
    data () {
      return {
        search_words:"",
        search_type:"business",
      }
  },

    methods: {
   
        search(){
            location.replace("search?search="+this.search_type+"&k="+this.search_words)
        },
     
    },
}
</script>


// WEBPACK FOOTER //
// searchbox.vue?7de4976f